/**
 * Faz 8 (finans ve analitik) kök çeviri parçaları — Türkçe: hata kodları ve yetki adları. `tr.ts`'teki `errors` ve
 * `permissions` nesnelerine tek satırla eklenir (ADR-801).
 */
export const faz8ErrorsTr = {
  shipment_cost_exists: 'Bu gönderinin kargo maliyeti zaten girilmiş; mevcut kaydı düzenleyin.',
  vat_exceeds_amount: 'KDV tutarı, toplam tutardan büyük olamaz.',
  tracking_not_found: 'Bu takip numarasıyla gönderi bulunamadı.',
  tracking_ambiguous: 'Bu takip numarası birden çok gönderide var; maliyeti gönderi ekranından girin.',
  duplicate_in_file: 'Bu takip numarası dosyada birden çok kez geçiyor.',
  amount_required: 'Tutar boş veya okunamadı.',
  date_unreadable: 'Tarih okunamadı (GG.AA.YYYY veya YYYY-AA-GG).',
  cost_file_columns_missing: 'Dosyada "Takip no" ve "Tutar" sütunları bulunamadı.',
  supplier_code_exists: 'Bu kodla bir tedarikçi zaten var.',
  supplier_inactive: 'Tedarikçi pasif; önce tedarikçiyi etkinleştirin.',
  purchase_order_not_editable:
    'Sipariş tedarikçiye verildikten sonra satırlar, depo ve para birimi değiştirilemez; yalnızca beklenen tarih ve not düzenlenir.',
  purchase_order_status: 'Bu işlem siparişin şimdiki durumunda yapılamaz.',
  purchase_order_not_receivable:
    'Yalnızca tedarikçiye verilmiş ve tamamı alınmamış siparişe mal kabul yapılır.',
  warehouse_inactive: 'Depo pasif; mal kabul için depoyu etkinleştirin.',
  duplicate_variant: 'Aynı ürün siparişte birden çok satırda olamaz; adedi tek satırda girin.',
  over_receipt: 'Kabul edilen adet kalan adetten fazla; fazla teslimi kabul etmek için işaretleyin.',
  duplicate_line: 'Aynı sipariş satırı bir kabulde iki kez girilemez.',
  lot_expiry_mismatch: 'Bu lot numarası farklı bir son kullanma tarihiyle kayıtlı.',
  supplier_entry_not_reversible:
    'Mal kabul faturası ters çevrilemez; farkı düzeltme kaydıyla giderin. Ters kaydın tersi de alınmaz.',
  report_metric_invalid: 'Bu metrik seçilen veri kümesinde yok.',
  report_dimension_invalid: 'Bu boyut seçilen veri kümesinde yok.',
  report_duplicate: 'Aynı metrik veya boyut iki kez seçilemez.',
  report_pivot_one_metric: 'Sütun boyutu (pivot) seçildiğinde tek metrik seçilir.',
  report_filter_invalid: 'Bu süzgeç seçilen veri kümesinde kullanılamaz.',
  report_definition_invalid: 'Rapor tanımı okunamadı.',
  dashboard_widget_limit: 'Ana panele en çok {{max}} bileşen eklenebilir.',
  dashboard_widget_exists: 'Bu rapor ana panelinizde zaten var.',
  widget_order_mismatch: 'Sıralama bütün bileşenleri bir kez içermeli.',
  report_export_not_ready: 'Dosya henüz hazır değil veya hazırlanamadı.',
  report_export_too_large: 'Dosya 20 MB sınırını aşıyor; süzgeç ekleyin veya satır boyutlarını azaltın.',
  report_member_inactive: 'Kullanıcının üyeliği etkin değil; dosya üretilmedi.',
  no_eligible_recipient: 'Raporu görebilecek yetkide alıcı yok; hiçbir e-posta gönderilmedi.',
  payment_not_disputable:
    'İtiraz yalnızca kartla (iyzico, PayTR) veya fiziki POS ile alınmış, tahsil edilmiş ödemeye açılır.',
  dispute_exceeds_payment: 'İtiraz tutarı, ödemenin itirazda olmayan tutarını aşıyor.',
  dispute_fee_too_large: 'İtiraz ücreti ödeme tutarından büyük olamaz.',
  dispute_case_exists: 'Bu ödemede aynı dosya numarasıyla bir itiraz zaten var.',
  dispute_status_transition: 'İtiraz bu durumdan bu duruma geçirilemez.',
  date_before_opened: 'Bu tarih, itirazın açıldığı tarihten önce olamaz.',
  date_after_closed: 'Açılış tarihi, kapanış tarihinden sonra olamaz.',
  simulation_currency_unsupported: 'Fiyat simülasyonu şimdilik yalnızca TL fiyat listelerinde yapılır.',
  // Otomasyon kurucusu (F8-15)
  workflow_field_invalid: 'Bu alan seçilen tetikleyicide yok.',
  workflow_operator_invalid: 'Bu karşılaştırma bu alanla kullanılamaz.',
  workflow_value_invalid: 'Değer bu alana uygun değil (sayı, seçenek veya metin bekleniyor).',
  workflow_actions_required: 'En az bir eylem ekleyin.',
  workflow_action_incompatible: 'Bu eylem seçilen tetikleyiciyle kullanılamaz.',
  workflow_recipient_invalid: 'Alıcılardan biri işletmenin etkin üyesi değil.',
  saved_report_not_found: 'Kayıtlı rapor bulunamadı veya bu raporu göremiyorsunuz.',
  workflow_template_linked:
    'Bu örnek müşteriye ileti gönderir; izin ve İYS denetimi için kendi bölümünden yönetilir.',
  workflow_archived: 'Arşivdeki akış değiştirilemez ve açılamaz.',
  workflow_active: 'Açık akış arşivlenemez; önce durdurun.',
  workflow_run_not_retryable: 'Yalnızca başarısız çalışma yeniden denenir.',
  workflow_not_active: 'Akış açık değil; yeniden denemek için önce akışı açın.',
  workflow_run_not_cancellable: 'Yalnızca bekleyen çalışma iptal edilir.',
  workflow_subject_missing: 'Olayda bu eylem için gereken kayıt yok.',
  owner_inactive: 'Akışı açan kişinin üyeliği etkin değil.',
  no_recipient: 'Bu ayarla e-posta gönderilecek etkin üye yok.',
  seo_issues: 'SEO sorunları var.',
  order_not_paid: 'Sipariş "ödendi" durumunda değil; dokunulmadı.',
  order_not_found: 'Sipariş bulunamadı.',
  product_not_found: 'Ürün bulunamadı.',
  post_not_found: 'Yazı bulunamadı.',
  already_published: 'Onaylanan hâli zaten yayında.',
  invoice_uncertain:
    "Fatura gönderiminin sonucu belirsiz; BizimHesap'ta kontrol edip Faturalar sayfasından işaretleyin.",
  invoice_send_failed: "Fatura BizimHesap'a gönderilemedi; Faturalar sayfasından yeniden gönderin.",
  workflow_paused: 'Akış durduruldu; bekleyen çalışma iptal edildi.',
  manual_retry: 'Çalışma elle yeniden denendi.',
  too_short: 'Metin çok kısa.',
  invalid: 'Geçersiz değer.',
} as const;

export const faz8PermissionsTr = {
  'reports.finance.manage':
    'Finans girdilerini yönetme (ödeme komisyonu kuralları, kargo maliyetleri, işletme giderleri)',
  'purchasing.read': 'Tedarikçi ve satın almayı görme (maliyetler ve tedarikçi bakiyeleri dahil)',
  'purchasing.manage': 'Tedarikçi ve satın alma siparişi yönetme',
  'purchasing.receive': 'Mal kabul (satın alma siparişine stok girişi)',
  'purchasing.ledger.manage': 'Tedarikçi cari kayıtları (ödeme, iade, açılış, düzeltme)',
  'reports.custom.read': 'Özel raporları çalıştırma ve paylaşılanları görme (veriyi kendi yetkileriyle)',
  'reports.custom.manage': 'Özel rapor kaydetme ve paylaşma',
  'reports.schedule.manage': 'Zamanlanmış rapor (işletme üyelerine e-postayla indirme bağlantısı)',
  'payments.dispute.manage': 'Ödeme itirazı (ters ibraz) kaydı, durumu, notu ve belgesi',
  'workflows.read': 'Otomasyon akışlarını ve çalışma kaydını görme',
  'workflows.manage':
    'Otomasyon akışı oluşturma, açma/durdurma ve yeniden deneme (eylemler açan kişinin yetkisiyle çalışır)',
} as const;
